// extracted by mini-css-extract-plugin
export default {"price":"G5-z","onSale":"H5-z","msrpLabelPrice":"I5-z","msrpLabel":"J5-z","originalPrice":"K5-z","percentOff":"L5-z"};